import axios from 'axios'
import * as Sentry from '@sentry/nextjs'

const getConversionTrackingConfig = () => ({
  url: process.env.CONVERSION_TRACKING_URL || '',
  partnerId: process.env.CONVERSION_TRACKING_PARTNER_ID || '',
  merchantChanged: process.env.CONVERSION_TRACKING_MERCHANT_CHANGED || '',
})

export const trackGoogleConversion = async (rwgToken: string) => {
  try {
    const { url, partnerId, merchantChanged } = getConversionTrackingConfig()

    if (!url || !partnerId || !merchantChanged) {
      console.log('Missing required environment variables for Google conversion tracking')
      return {
        isOk: false,
      }
    }

    const body = JSON.stringify({
      conversion_partner_id: partnerId,
      rwg_token: rwgToken,
      merchant_changed: merchantChanged,
    })

    await axios.post(url, body, {
      headers: {
        'Content-Type': 'text/plain',
      },
    })

    return {
      isOk: true,
    }
  } catch (error) {
    Sentry.captureException(error instanceof Error ? error : new Error(String(error)), {
      tags: { api: 'trackGoogleConversion' },
    })

    return {
      isOk: false,
    }
  }
}
